<template>
  <div class="content">
    <div class="tit">客户登记表</div>
    <div class="line_left">
      <span class="name">
         <img src="../../assets/img/flower.png" alt="" class="flower">
        姓 名：</span>
      <input type="text" placeholder="请输入您的姓名" v-model="name" class="lineinput">
    </div>
    <div class="line_left">
      <span class="name">
        <img src="../../assets/img/flower.png" alt="" class="flower">
        电 话：</span>
      <input type="text" placeholder="请输入您的联系方式" v-model="phone" class="lineinput">
      <div class="tip">
        <p class="tiptit">微信同号</p>
        <p class="tiptwo" v-if="no==false"><img src="../../assets/img/no.png" alt="" class="imgwx" @click="nono"></p>
        <p class="tiptwo" v-else><img src="../../assets/img/yes.png" alt="" class="imgwx" @click="yes"></p>
      </div>
    </div>
    <div class="line_left">
      <span class="name">
        <img src="../../assets/img/flower.png" alt="" class="flower">
        年 龄：</span>
      <input type="text" placeholder="请输入您的年龄" v-model="age" class="lineinput">
    </div>
    <div class="line_left">
      <span class="name">
         <img src="../../assets/img/flower.png" alt="" class="flower">
        婚姻状况：</span>
      <span v-for="(item,index) in list" :key="index" :class="choosen==index?'blue':'gery'" @click="choose(item.id,item.state)">{{item.state}}</span>
    </div>
    <div class="line_left">
      <span class="name">职 业：</span>
      <span v-for="(item,index) in list2" :key="index" :class="choosen2==index?'blue':'gery'" @click="mast(item.id,item.state)">{{item.state}}</span>
    </div>
    <div class="line_left">
      <span class="name">所在区域：</span>
      <input type="text" placeholder="请输入您的所在区域" class="lineinput" v-model="region">
    </div>

    <div class="line_left">
      <span class="name">社 保：</span>
      <span v-for="(item,index) in list3" :key="index" :class="choosen3==index?'blue':'gery'" @click="identy(item.id,item.state)">{{item.state}}</span>
    </div>
    <div class="line_left">
      <span class="name">户籍：</span>
      <input type="text" placeholder="请输入您的户籍" class="lineinput" v-model="census">
    </div>
    <div class="line_left">
      <span class="name">年收入：</span>
      <input type="text" placeholder="请输入您的年收入" class="lineinput" v-model="annualIncome">
    </div>
    <div class="line_left">
      <span class="name">购房需求：</span>
      <span v-for="(item,index) in list4" :key="index" :class="choosen4==index?'blue':'gery'" @click="buy(item.id,item.state)">{{item.state}}</span>
    </div>
    <div class="line_left">
      <span class="name">意向区域：</span>
      <input type="text" placeholder="请输入您的购房意向区域" class="lineinput" v-model="intentionRegion">
    </div>
    <div class="line_left">
      <span class="name">购房类型：</span>
      <span v-for="(item,index) in list5" :key="index" :class="choosen5==index?'blue':'gery'" @click="get(item.id,item.state)">{{item.state}}</span>
    </div>
    <div class="line_left2">
      <span class="name">经营简介：</span>
      <textarea type="text" placeholder="请输入您的经营简介" class="textarae" v-model="manageIntroduce"></textarea>
    </div>
    <div :class="creditReport.length>0?'line_left7':'line_left3'">
      <span class="name">征信报告：</span>
      <div class='uploader'>
        <Upload
            ref="upload"
            :show-upload-list="false"
            :before-upload="handleBeforeUpload"
            type="drag"
            action="https://www.fangpinyouxuan.com/huiyuan/api/dispatcher"
            :data="uploadData"
            :on-success="uploadSuccess"
            style=""
            class="alluploader"
        >
          <Button icon="ios-cloud-upload-outline" type="text"
           class="allbutun"> <img src="../../assets/img/up.png" alt="" class="allupimg"></Button
          >
<!--          <img src="../../assets/img/up.png" alt="" class="allupimg">-->
        </Upload>

        <div class="img_item" v-if="creditReport.length>0">
          <div class="imgmes" v-for="(item,a) in creditReport" :key="a">
            <el-image
                :src="item"
                alt=""
                :preview-src-list= "[item]"
            ></el-image>
          </div>
        </div>
      </div>
    </div>
    <div :class="businessLicense.length>0?'line_left7':'line_left3'">
      <span class="name">营业执照：</span>
      <div class='uploader'>
        <Upload
            ref="upload"
            :show-upload-list="false"
            :before-upload="handleBeforeUpload2"
            type="drag"
            action="https://www.fangpinyouxuan.com/huiyuan/api/dispatcher"
            :data="uploadData"
            :on-success="uploadSuccess2"
            style=""
            class="alluploader"
        >
          <Button icon="ios-cloud-upload-outline" type="text"
                  class="allbutun"> <img src="../../assets/img/up.png" alt="" class="allupimg"></Button
          >
          <!--          <img src="../../assets/img/up.png" alt="" class="allupimg">-->
        </Upload>

        <div class="img_item" v-if="businessLicense.length>0">
          <div class="imgmes" v-for="(item,a) in businessLicense" :key="a">
            <el-image
                :src="item"
                alt=""
                :preview-src-list= "[item]"
            ></el-image>
          </div>
        </div>
      </div>
    </div>
    <div :class="premises.length>0?'line_left7':'line_left3'">
      <span class="name">经营场所：</span>
      <div class='uploader'>
        <Upload
            ref="upload"
            :show-upload-list="false"
            :before-upload="handleBeforeUpload3"
            type="drag"
            action="https://www.fangpinyouxuan.com/huiyuan/api/dispatcher"
            :data="uploadData"
            :on-success="uploadSuccess3"
            style=""
            class="alluploader"
        >
          <Button icon="ios-cloud-upload-outline" type="text"
                  class="allbutun"> <img src="../../assets/img/up.png" alt="" class="allupimg"></Button
          >
          <!--          <img src="../../assets/img/up.png" alt="" class="allupimg">-->
        </Upload>

        <div class="img_item" v-if="premises.length>0">
          <div class="imgmes" v-for="(item,a) in premises" :key="a">
            <el-image
                :src="item"
                alt=""
                :preview-src-list= "[item]"
            ></el-image>
          </div>
        </div>
      </div>
    </div>
    <div class="btn" @click="submit">提交</div>
    <div class="right_tit">
      <p class="p2">以上信息请务必详细真实填写，为您更快找寻匹配房源及制定可行方案</p>
    </div>
  </div>
</template>

<script>
import { uploadimg } from "@/api/ajax.js";
import {
  clos_encryptDes,
  clos_encryptDes1,
  clos_encryptDes2,
  clos_encryptDesForApp,
  time as initTime,
} from "@/encryption";
import {Toast} from "vant";
import {getCheckCode} from "api/ajax";
export default {
  name: "Advertise",
  data() {
    return {
      list:[{state:'已婚',id:0},{state:'未婚',id:1}],
      list3:[{state:'有',id:0},{state:'无',id:1}],
      list4:[{state:'投资',id:0},{state:'自住',id:1}],
      list5:[{state:'住宅',id:0},{state:'公寓',id:1},{state:'商铺',id:2},{state:'写字楼',id:3}],
      choosen:0,
      choosen2:0,
      choosen3:0,
      choosen4:0,
      choosen5:0,

      no:false,
      content:'',
      list2:[{state:'个体户',id:0},{state:'营业主',id:1},{state:'其他',id:2}],


      imgpath: [],
      imgpath2: [],
      imgpath3: [],
      uploadData: {

      },//额外上传文件的参数

      fileExtension:'',
      fileExtension2:'',
      fileExtension3:'',
      uploader8:[], //单位信息【不通过】，3年个税(社保)材料不符
      form:{
        imgUrls8:[],
      },
      name:'',//姓名
      phone:'',//电话
      age:'',//年龄
      marriage:'已婚',//婚姻
      job:'个体户',//职业
      region:'',//区域
      socialSecurity:'有',//社保
      census:'',//户籍
      annualIncome:'',//年收入
      housePurchase:'投资',//购房需求
      intentionRegion:'',//意向区域
      purchaseTyp:'住宅',//购房类型
      manageIntroduce:'',//经营简介
      creditReport:[],//经营报告
      businessLicense:[],//营业执照
      premises:[],//经营场所
      wechatNumber:'否'

    };
  },
  computed: {

  },
  mounted() {
    // this.submit()
  },
  methods: {
    // 文件上传的事件钩子
    // eslint-disable-next-line no-unused-vars
    handleBeforeUpload(file) {
      // this.fileExtension3=file.name.split(".").pop().toLowerCase();
      if(this.creditReport.length>=3){
        Toast.fail('不能超过3张图片');
        return false
      }
      else {
        let action = "scattered.uploadFile";
        let deviceId = "abc123";
        const time = this.time();
        // const time ='1616389200';

        console.log(file,'00000')
        this.uploadData.action = "scattered.uploadFile",
            this.uploadData.accessKeyId = "APId1482c4fc9",
            this.uploadData.signature =clos_encryptDes(deviceId,action,time)
        this.uploadData.deviceId =deviceId
        console.log(this.uploadData.signature,'合适嘛')
        this.uploadData.timestamp = time
      }
    },
    // eslint-disable-next-line no-unused-vars
    uploadSuccess(res,file,list){
      console.log(res.data,"文件路径")
      this.creditReport.push(res.data)
    },
    handleBeforeUpload2(file) {
      // this.fileExtension2=file.name.split(".").pop().toLowerCase();
      if(this.imgpath2.length>=3){
        Toast.fail('不能超过3张图片');
        return false
      }
      // else if(
      //     this.fileExtension2 != "jpg" &&
      //     this.fileExtension2 != "jpeg" &&
      //     this.fileExtension2 != "png" &&
      //     this.fileExtension2 != "webp"
      // ){
      //   Toast.fail('文件格式不正确');
      //   return false
      // }
      else {
        let action = "scattered.uploadFile";
        let deviceId = "abc123";
        const time = this.time();
        // const time ='1616389200';

        console.log(file,'00000')
        this.uploadData.action = "scattered.uploadFile",
            this.uploadData.accessKeyId = "APId1482c4fc9",
            this.uploadData.signature =clos_encryptDes(deviceId,action,time)
        this.uploadData.deviceId =deviceId
        console.log(this.uploadData.signature,'合适嘛')
        this.uploadData.timestamp = time
      }
      //return false
    },
    // eslint-disable-next-line no-unused-vars
    uploadSuccess2(res,file,list){
      console.log(res.data,"文件路径")
      this.businessLicense.push(res.data)

      // console.log( this.businessLicense,'图片数组')
    },
    handleBeforeUpload3(file) {
      // this.fileExtension=file.name.split(".").pop().toLowerCase();
      if(this.premises.length>=3){
        Toast.fail('不能超过3张图片');
        return false
      }
      // else if(
      //     this.fileExtension != "jpg" &&
      //     this.fileExtension != "jpeg" &&
      //     this.fileExtension != "png" &&
      //     this.fileExtension != "webp"
      // ){
      //   Toast.fail('文件格式不正确');
      //   return false
      // }
      else{
        let action = "scattered.uploadFile";
        let deviceId = "abc123";
        const time = this.time();
        // const time ='1616389200';
        console.log(file,'00000')
        this.uploadData.action = "scattered.uploadFile",
            this.uploadData.accessKeyId = "APId1482c4fc9",
            this.uploadData.signature =clos_encryptDes(deviceId,action,time)
        this.uploadData.deviceId =deviceId
        console.log(this.uploadData.signature,'合适嘛')
        this.uploadData.timestamp = time
      }
      //return false
    },
    // eslint-disable-next-line no-unused-vars
    uploadSuccess3(res,file,list){
      console.log(res.data,"文件路径")
      this.premises.push(res.data)
    },
    choose(e,f){
      this.choosen=e
      this.marriage=f
      console.log(this.marriage,'99')
    },
    mast(e,f){
      // console.log(e,'啥')
      this.choosen2=e
      this.job=f
    },
    identy(e,f){
      this.choosen3=e
      this.socialSecurity=f
    },
    buy(e,f){
      this.choosen4=e
      this.housePurchase=f
    },
    get(e,f){
      this.choosen5=e
      this.purchaseTyp=f
    },
    nono(){
      this.no=true
      this.wechatNumber='是'
      // console.log(this.wechatNumber,'99')
    },
    yes(){
      this.no=false
      this.wechatNumber='否'
      // console.log(this.wechatNumber,'99')
    },
    async submit() {
      if(this.name==''){
        Toast.fail('姓名不能为空');
        return false
      }
      if(this.phone==''){
        Toast.fail('电话不能为空');
        return false
      }
      if(this.phone==''){
        Toast.fail('电话不能为空');
        return false
      }
      if(this.age==''){
        Toast.fail('年龄不能为空');
        return false
      }
      let time = this.time()
      console.log(JSON.stringify(this.businessLicense),'图片数组')
      let args = {
        action: "scattered.getInfoFromCommunity",
        name:this.name,//姓名
        phone:this.phone,//电话
        wechatNumber:this.wechatNumber,
        age:this.age,//年龄
        marriage:this.marriage,//婚姻
        job:this.job,//职业
        region:this.region,//区域
        socialSecurity:this.socialSecurity,//社保
        census:this.census,//户籍
        annualIncome:this.annualIncome,//年收入
        housePurchase:this.housePurchase,//购房需求
        intentionRegion:this.intentionRegion,//意向区域
        purchaseTyp:this.purchaseTyp,//购房类型
        manageIntroduce:this.manageIntroduce,//经营简介
        creditReport:JSON.stringify(this.creditReport),//经营报告
        businessLicense:JSON.stringify(this.businessLicense),//营业执照
        premises:JSON.stringify(this.premises),//经营场所
        timestamp:time
      };
      let response = await getCheckCode(args);
      let {statusCode, success} = response
      if (statusCode === 201 && success== true) {
        Toast.success('客户信息提交成功');
      } else {
        Toast.fail('客户信息提交失败');
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.content{
  padding: 16px;
  .tit{
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    text-align: center;
    height: 50px;
    line-height: 40px;
  }
  .line_left{
    height: 60px;
    line-height: 60px;
    border-bottom: 0.5px solid #F0F0F0;
    .uppng{
      width: 95.99em;
      height: 86.99em;
    }
    .name{
     display: inline-block;
      width: 88px;
      font-size: 14px;
      .flower{
        width: 8px;
        height: 8px;
        margin-right: 4px;

      }
    }

    .blue{
      background-color:#0081ff;
      padding: 5px 10px;
      color: white;
      font-size: 12px;
      border-radius: 10px;
      height: 10px;
      line-height: 10px;
      margin-right: 10px;
    }
    .gery{
      background-color:white;
      border: 1px solid #cccccc;
      padding: 5px 10px;
      color: #cccccc;
      font-size: 12px;
      border-radius: 10px;
      height: 10px;
      line-height: 10px;
      margin-right: 10px;
    }
    .lineinput{
      outline: none;
      border:none;
      height: 57px;
      font-size: 13px;
    }
    .tip{
      width: 60px;
      float: right;
      margin-top: -10px;
      .tiptit{
        text-align: right;
       //float: right;
        height: 25px;
        font-size: 11px;
      }
      .tiptwo{
        height: 20px;
        float: right;
        .imgwx{
          width: 24px;
          height: 14px;
        }
      }
    }
  }
  .line_left3{
    height: 120px;
    //line-height: 60px;
    border-bottom: 0.5px solid #F0F0F0;
    position: relative;

    .name{
      display: inline-block;
      width: 78px;
      //margin-top: 30px;
      font-size: 14px;
      .flower{
        width: 8px;
        height: 8px;
        margin-right: 4px;
      }
    }
    .uploader{
      //width: 100%;
      position: relative;
      z-index: 99;
      //height: 99px;

      .alluploader{
       width: 20%;
        margin-left: 80px;
        .ivu-upload{
          width: 30px;
          .ivu-upload-input{
            width: 20% !important;
          }
          input{
            width: 20% !important;
          }
          .allbutun{
            //width: 200px;
            //height: 32px;
            ///* margin-top: -62.4vw; */
            position: absolute;
            width: 96px;
            height: 87px;
            top: -1px;
            left: 70px;
            .allupimg{
              position: absolute;
              left:-2px;
              top:-2px;
              width: 96px;
              height: 87px;
              //z-index: 1;
              //opacity: 1;

              //width: 200px;
              //height: 100px;
              //position: absolute;
              //left: 0;
              //top: 0;
            }
          }
        }


      }
      .img_item{
         display: flex;
        justify-content: space-between;
        margin-top: 84px;
        width: 70%;
        box-sizing: border-box;
        height: 100px;
        .imgmes{
          width: 97px;
          height: 87px;
          .el-image{
            img{
              width: 97px;
              height: 87px;
            }

          }
        }
      }
    }

  }
  .line_left7{
    height: 200px;
    //line-height: 60px;
    border-bottom: 0.5px solid #F0F0F0;
    position: relative;

    .name{
      display: inline-block;
      width: 78px;
      font-size: 14px;
      //margin-top: 30px;
      .flower{
        width: 8px;
        height: 8px;
        margin-right: 4px;
      }
    }
    .uploader{
      //width: 100%;
      position: relative;
      z-index: 99;
      //height: 99px;

      .alluploader{
        width: 20%;
        margin-left: 80px;
        .ivu-upload{
          width: 30px;
          .ivu-upload-input{
            width: 20% !important;
          }
          input{
            width: 20% !important;
          }
          .allbutun{
            //width: 200px;
            //height: 32px;
            ///* margin-top: -62.4vw; */
            position: absolute;
            width: 96px;
            height: 87px;
            top: -1px;
            left: 70px;
            .allupimg{
              position: absolute;
              left:-2px;
              top:-2px;
              width: 96px;
              height: 87px;
              //z-index: 1;
              //opacity: 1;
              //width: 200px;
              //height: 100px;
              //position: absolute;
              //left: 0;
              //top: 0;
            }
          }
        }


      }
      .img_item{
        display: flex;
        justify-content: space-between;
        margin-top: 84px;
        width: 70%;
        box-sizing: border-box;
        height: 100px;
        .imgmes{
          width: 97px;
          height: 87px;
          .el-image{
            img{
              width: 97px;
              height: 87px;
            }

          }
        }
      }
    }

  }
  .line_left2{
    height: 90px;
    //line-height: 90px;
    border-bottom: 0.5px solid #F0F0F0;
    clear: both;
    .name{
      margin-top: 10px;
      float: left;
      display: inline-block;
      width: 88px;
      font-size: 14px;
    }
    .textarae{
      outline: none;
      border:none;
      height: 80px;
      margin-top: 10px;
      font-size: 13px;
    }
  }
  .right_tit{
    font-size: 14px;
    font-weight: 600;
    color: #444;
    line-height: 24px;
    padding-bottom: 30px;
    p{
      font-size: 14px;
      font-weight: normal;
    }
    .p2{
      font-size: 14px;
      font-weight: bold;
      color: #333333;
      height: 37px;
      line-height: 37px;
    }
  }
  .btn{
    width: 100%;
    margin: 15px auto;
    color: white;
    text-align: center;
    height: 40px;
    border-radius: 22px;
    line-height: 40px;
    background-color: #0081ff;
    font-size: 16px;
  }
}
</style>
<style>

.alluploader input{
  width:30% !important;
}
.imgmes .el-image__error, .el-image__inner, .el-image__placeholder {
  width: 97px;
  height: 87px;
}

</style>
